import { BasicController } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { SimpleCommand } from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

export class Poker2RegisterUserCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        var email: string = commandVars.email;
        var password: string = commandVars.password;
        var username: string = commandVars.username;

        var paramObject: any = { name: username, connectMillis: BasicModel.smartfoxClient.connectionTime };
        BasicController.getInstance().registerJSON(email, password, paramObject);
    }
}
classImplementsInterfaces(Poker2RegisterUserCommand, "ISimpleCommand");
